import { SupervisorAccountOutlined } from '@mui/icons-material';
import { Box, ButtonBase, Paper, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { useAppDispatch } from '@/hooks/redux-hooks';
import { clearImpostorTokenFromStorage, useImpersonatorEmailFromStorage } from '@/services/storage';
import { getUserConfig } from '@/slices/userConfigSlice';
import { RootState } from '@/store';

export const ImpersonatorBanner = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const handleExitImpersonatorMode = () => {
    clearImpostorTokenFromStorage();
    dispatch(getUserConfig());
    navigate('/');
  };
  const impersonatorEmail = useImpersonatorEmailFromStorage();

  const tripTokenState = useSelector((state: RootState) => state.tripToken);

  if (!impersonatorEmail) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        gap: 3
      }}
    >
      <Paper
        sx={{
          width: '100%',
          height: '48px',
          backgroundColor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          mb: 3
        }}
      >
        <Typography>
          You are logged in as <span style={{ fontWeight: 700 }}>{tripTokenState.userEmail}</span>
        </Typography>
        <ButtonBase
          sx={{
            width: 120,
            height: 32,
            ml: 3,
            px: 1,
            backgroundColor: 'gx.actionBarButtonTile',
            fontSize: 12
          }}
          onClick={handleExitImpersonatorMode}
        >
          <SupervisorAccountOutlined sx={{ fontSize: 18, mr: 0.5 }} /> Switch back
        </ButtonBase>
      </Paper>
    </Box>
  );
};
